/**
 * Shared streak utilities for Perfect Slice + Dead Center.
 * Exported from a single place so both games stay in sync.
 */

/**
 * Compute Dead Center streak from a history array (each item: { date: 'YYYY-MM-DD', ... }).
 * Returns consecutive UTC calendar days ending on today or yesterday.
 */
export function computeDcStreak(days) {
  if (!Array.isArray(days) || !days.length) return 0;
  const dateSet = new Set(days.map(d => d.date));
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const todayStr = today.toISOString().slice(0, 10);
  const check    = new Date(today);
  if (!dateSet.has(todayStr)) check.setUTCDate(check.getUTCDate() - 1);
  let streak = 0;
  while (dateSet.has(check.toISOString().slice(0, 10))) {
    streak++;
    check.setUTCDate(check.getUTCDate() - 1);
  }
  return streak;
}

/**
 * Return true if Dead Center was completed on today's UTC date.
 */
export function isDcCompletedToday(days) {
  if (!Array.isArray(days)) return false;
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const todayStr = today.toISOString().slice(0, 10);
  return days.some(d => d.date === todayStr);
}

/* ─── Milestone helpers ─────────────────────────────────────────────────── */

const MILESTONES = [7, 30];

/**
 * Returns the milestone streak number if this is a new achievement today,
 * or null if it was already celebrated or isn't a milestone number.
 * Uses localStorage to prevent re-showing within the same UTC day.
 */
export function checkStreakMilestone(gameSlug, streak) {
  if (!MILESTONES.includes(streak)) return null;
  try {
    const today = new Date().toISOString().slice(0, 10);
    const key   = `cp.milestone.${gameSlug}.${streak}.${today}`;
    if (localStorage.getItem(key)) return null;
    localStorage.setItem(key, '1');
    return streak;
  } catch {
    // localStorage unavailable (private mode, etc.)
    return null;
  }
}
